import { Component, OnInit, OnDestroy, ViewChild, ElementRef, } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { MediaElementPlayer } from 'mediaelement';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-mediapopup',
  templateUrl: './mediapopup.page.html',
  styleUrls: ['./mediapopup.page.scss'],
})
export class MediapopupPage implements OnInit, OnDestroy {
  Type: any;
  Path: any;
  ThumNail: any;
  id: string = 'vdo';
  dataURL: any;
  Pageloading: boolean = false;
  isLoading: boolean = true;
  vediopath: any;
  @ViewChild('videoPlayer', { static: false })
  videoPlayer: MediaElementPlayer;
  showVideo = false;
  private playTimeout: any;
  private loaderTimeout: any;
  Nurse_Calender: any;
  fromDate: any;
  toDate: any;
  nurseYear: any;
  nurseMonth: any;
  changeMonth: any;
  excluded_datess: any;
  excluded_update:any;
  dutyFromDate:any;
  dutyToDate:any;
  isChangedMonth:boolean = false;
  isSearchOnce:boolean = false;
  constructor(
    public modalCtrl: ModalController,
    private loadingController: LoadingController,
    public addCall: AddCall
  ) { }

  ngOnInit() {
    console.log(this.excluded_datess,"12345");
    this.excluded_update = this.excluded_datess.split(",");
    console.log(this.excluded_update,444)
    debugger;
    setTimeout(() => {
      this.showVideo = true;
      this.videoPlayer.nativeElement.play();
    }, 1000);
    this.Pageloading = false;
  }

  ionViewWillEnter() {
    this.initial();
    console.log(this.Nurse_Calender, "nurse");
    this.getBkgDateCale(new Date(this.fromDate), new Date(this.toDate))

    setTimeout(() => {
      this.showVideo = true;
      this.videoPlayer.nativeElement.play();
    }, 1000);
  }

  ionViewWillLeave(){
    this.isChangedMonth = true;
  }
  videoLoaded() {
    this.Pageloading = true;
    const videoElement = this.videoPlayer.nativeElement;
    videoElement.onplay = () => {
      videoElement.style.opacity = '1'; // Ensure opacity is set to 1 when playing
    };
  }
  initial() {
    this.loaderTimeout = setTimeout(() => {
      this.isLoading = false;
      this.playTimeout = setTimeout(() => {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
          this.videoPlayer.nativeElement.play();
        }
      }, 1500);
    }, 100);
  }

  toggleVideo(videoElement: HTMLVideoElement) {
    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  }

  onImageError(event: Event) {
    const element = event.target as HTMLImageElement;
    element.src = 'assets/img/Vector.png';
  }

  close() {
    this.modalCtrl.dismiss();
  }

  ngOnDestroy() {
    // Cleanup when the component is destroyed
    if (this.playTimeout) {
      clearTimeout(this.playTimeout);
    }
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
    }
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      const videoElement = this.videoPlayer.nativeElement;
      videoElement.pause();
      videoElement.src = '';
      videoElement.load();
    }
  }


  //Defined Duties Functions =======================

  storeDates: any = [];
  excludedDate: any = [];
  completedDays: any = [];
  pendingDays: any = [];

  getBkgDateCale(fromDate, toDate) {

    this.excludedDate = this.excluded_update;
    let compDays = [];
    let pendDays = [];

    compDays.forEach((item) => {
      this.completedDays.push(this.dateConvertion(item))
    });
    pendDays.forEach((item) => {
      this.pendingDays.push(this.dateConvertion(item))
    });

    console.log("his.completedDays", this.completedDays);
    console.log("his.completedDays", this.pendingDays);

    debugger
    this.storeDates = [];
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);
    const duty_FromDate = new Date(this.dutyFromDate);
    const duty_ToDate = new Date(this.dutyToDate);
    let exStatus = false;

    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excldDate: exStatus
        });
      }
    }
    console.log("?joy", this.storeDates);

    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
    console.log("monthEnd=>", monthEnd);
    for (let i = 1; i <= monthEnd; i++) {
      for (let item of this.excludedDate) {
        let eD = new Date(item);
        let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
        let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
        if (exDate == date) {
          exStatus = true;
          break;
        }
        else {
          exStatus = false;
        }
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        excldDate: exStatus
      });
      exStatus = false;
    }
    for (let i = 0; i < this.storeDates.length; i++) {
      if((this.storeDates[i].fullDate >= new Date(duty_FromDate.setHours(0,0,0,0)) && this.storeDates[i].fullDate <= new Date(duty_ToDate.setHours(0,0,0,0))) && (this.storeDates[i].excldDate == false)){
        if(this.storeDates[i].fullDate <= new Date()){
          this.storeDates[i].compDate = true;
        }else{
          this.storeDates[i].compDate = false;
        }
        if(this.storeDates[i].fullDate >= new Date()){
          this.storeDates[i].pendDate = true;
        }else{
          this.storeDates[i].pendDate = false;
        }
      }
    }
    setTimeout(() => {
      if(this.isChangedMonth == false && this.isSearchOnce == false){
        this.isSearchOnce = true;
        this.getBkgDateCale(new Date(duty_FromDate), new Date(duty_FromDate));
      }
    }, 50);
    console.log("storeDate=>", this.storeDates);
  }


  dateConvertion(data) {
    let date = new Date(data);
    date.setHours(0, 0, 0, 0);
    let formattedDate = date.toString();
    return formattedDate;
  }


  isCompleted(dateOf: any): boolean {
    if (dateOf != " " && dateOf != undefined) {
      var changedDate = this.formatDate(dateOf)
    } else {
      changedDate = dateOf
    }
    let foundValue;
    foundValue = this.completedDays.find(
      (element) => element === changedDate
    );
    return foundValue;
  }

  isPending(dateOf: any): boolean {
    if (dateOf != " " && dateOf != undefined) {
      var changedDate = this.formatDate(dateOf)
    } else {
      changedDate = dateOf
    }
    let foundValue;
    foundValue = this.pendingDays.find(
      (element) => element === changedDate
    );
    return foundValue;
  }

  formatDate(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = '00';
    const minutes = '00';
    const seconds = '00';
    const formattedDate = `${dayName} ${monthName} ${day} ${year} ${hours}:${minutes}:${seconds} GMT+0530 (India Standard Time)`;

    return formattedDate;
  }

  next() {
    debugger
    this.isChangedMonth = true;
    let nowDate = new Date(this.changeMonth);
    let nextMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 1);
    let dateArray = String(nextMonth).split(' ');
    this.nurseYear = dateArray[3];
    this.nurseMonth = dateArray[1];
    this.getBkgDateCale(new Date(nextMonth), new Date(nextMonth));
    this.changeMonth = nextMonth;
  }
  prev() {
    this.isChangedMonth = true;
    let nowDate = new Date(this.changeMonth);
    let nextMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1);
    let dateArray = String(nextMonth).split(' ');
    this.nurseYear = dateArray[3];
    this.nurseMonth = dateArray[1];
    this.getBkgDateCale(new Date(nextMonth), new Date(nextMonth));
    this.changeMonth = nextMonth;
  }


  // ================Dates Avilable Funcyion
  

}
